import { render, staticRenderFns } from "./kontakt.vue?vue&type=template&id=2311e178"
import script from "./kontakt.vue?vue&type=script&lang=js"
export * from "./kontakt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalFormulareTelefoninput: require('/builds/p1ng-it/gnoema/frontend/components/global/formulare/Telefoninput.vue').default})
